export default "__VITE_ASSET__Chdr5nZy__"